import { AdmAPIList } from '@/api'

const api = new AdmAPIList();

export default {

  getTrainingList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getTrainingList(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getAgentTrainingList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getAgentTrainingList(param,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getTrainingDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getTrainingDetail(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getAgentTrainingDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getAgentTrainingDetail(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  createTraining({ state }, param) {
    return new Promise((resolve, reject) => {
      api.createTraining(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  editTraining({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editTraining(param,
        (json) => resolve(json),
        (err) => reject(err)
      )
    })
  },
}



// WEBPACK FOOTER //
// ./src/Adm/CPD/store/actions.js